import React, { FC } from "react"

import { DeviceDocument } from "../../../../contexts/devices-context"
import CameraModuleSettings from "./CameraModuleSettings"
import useModuleAttributes from "../../hooks/useModuleAttributes"

type DeviceCameraModuleSettingsProps = {
    device: DeviceDocument
}

const _DeviceCameraModuleSettings: FC<DeviceCameraModuleSettingsProps> = ({ device }) => {
    const attrs = useModuleAttributes<"duration">(device, "camera")

    return (
        <CameraModuleSettings
            attrs={attrs}
            organisation={device.organisation}
            group={device.group}
            device={device}
        />
    )
}

export default _DeviceCameraModuleSettings
